module.exports = __webpack_public_path__ + "img/038.2af56d0f.png";